export default [
  {
    description: 'Radar de Licitações',
    path: '/ferramentas/radar_licitacoes',
    name: 'radar_licitacoes',
    component: () => import('@/views/ferramentas/licitacoes/radar.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Histórico de Licitações',
    path: '/ferramentas/historico_licitacoes',
    name: 'historico_licitacoes',
    component: () => import('@/views/ferramentas/licitacoes/historico.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

